import { render, staticRenderFns } from "./setPhone.vue?vue&type=template&id=1b198bcc&scoped=true"
import script from "./setPhone.vue?vue&type=script&lang=js"
export * from "./setPhone.vue?vue&type=script&lang=js"
import style0 from "./setPhone.vue?vue&type=style&index=0&id=1b198bcc&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b198bcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/yto-crm-steward-h5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b198bcc')) {
      api.createRecord('1b198bcc', component.options)
    } else {
      api.reload('1b198bcc', component.options)
    }
    module.hot.accept("./setPhone.vue?vue&type=template&id=1b198bcc&scoped=true", function () {
      api.rerender('1b198bcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/reverseReturnOrder/components/setPhone.vue"
export default component.exports